export default __webpack_public_path__ + "maps-examples-simple-map-view-thumbnail-960-359506b42b0fb31c33569f631659767a.png";